import { actionTypes } from '../reducer';

export const updateError = (payload: { errorMessage: string, isShowPassportUpdateButton: boolean }) => ({
    type: actionTypes.UPDATE_ERROR,
    payload,
});
